<div
  class="dashboard-main"
  [ngClass]="{ 'dashboard-main-default': isLoginScreen }"
>
  <div class="header-main" *ngIf="!isLoginScreen">
    <app-header (sidebarToggle)="toggleSidebar()"></app-header>
  </div>

  <div class="main-content">
    <app-sidebar
      *ngIf="!isLoginScreen"
      [isToggled]="isSidebarToggled"
      [ngClass]="{ 'sidebar-expanded': isSidebarToggled }"
    ></app-sidebar>

    <div
      class="content"
      [ngClass]="{ 'main-content-expanded': isSidebarToggled }"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>